import React, { useCallback, useEffect, useState , useRef} from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import SriyanshCardHeader from "../../components/CardHeader";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CircularProgress from "@mui/material/CircularProgress";
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import dayjs from "dayjs";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import apiClient from "../../BaseUrl/apiClient.js";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
function SuitabilityEntry() {
  const navigate = useNavigate();
  const [suitabilityDone,setSuitabilityDone]=useState(null);
 const [pageLoader, setPageLoader] = useState(false);
  const [poNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poQuantity, setpoQuantity] = useState(0);
  const [poDate, setpoDate] = useState(null);
  const [ConsigneeName, setConsigneeName] = useState("");
  const { state } = useLocation();
  //const [indentId, setindentId] = useState(state.indent_id);
  let poNumberFromList = state.exppo ?? "";
  //const [poNumberFromList, setpoNumberFromList] = useState();
  let gatepassNumberFromList = state.expgatepass ?? "";
  // const [gatepassNumberFromList, setgatepassNumberFromList] = useState(
  //   state.expgatepass??''
  // );

  const cancelRemarkRef = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [receivedQuantity, setreceivedQuantity] = useState(0);
  const [receivedvalue, setreceivedvalue] = useState(0);

  const [suitableQty, setSuitableQuantity] = useState(0);

  const [reason, setReason] = useState("");

  const [item_receivedDate, setitemreceivedDate] = useState("");

  const [suitabilityDate, setsuitabilityDate] = useState(null);
  const [memoDate, setmemoDate] = useState(null);

  const [selectedOption, setSelectedOption] = useState("");

  // const [dateerror, setDateError] = useState("");

  // const [memodateerror, setmemoDateError] = useState("");

  const today = dayjs();
  //const [minCalDate, setMinCalDate] = useState(dayjs());
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [balanceqty, setBalanceqty] = useState(0);
  const [showRemark, setShowRemark] = useState(true);

  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasons, setRejectReasons] = useState([]);

  const handleClose = () => {
    navigate("../suitabilitylist", { replace: true });
  };

  const handleQuantityChange = (value) => {
    setSuitableQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);
    if (selvalue === "0") {
      setShowRemark(true);
      setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const fetchSuitabaleReason = async () => {
    try {
      const response = await apiClient.post("/unsuitabilityReasonList", {
        /* request payload if needed */
      });
      setRejectReasons(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchSuitabaleReason();
  }, []);

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    if (rejectReasons.length > 0) {
      setRejectReason(rejectReasons[0].id);
    }
  }, [rejectReasons]);

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const [unsuitablePOList, setunsuitablePOList] = useState([]);

  // const getUnsutablePOdata = useCallback(async () => {
  //     if (!poNumber || poNumber.trim() === "") return;
  //     if (!gatepassNumberFromList || gatepassNumberFromList.trim() === "") return;
  //   setButtonLoading(true);
  //   try {
  //     const response = await apiClient.post("/getUnsutablePO_by_PONumber", {
  //       ponumber: poNumber,
  //       gatepassnumber: gatepassNumberFromList,
  //     });


  //     if (response.data[0].unsuitabilitytype === "Suitable") {
  //       setSuitabilityDone("Suitable")
  //     } 
  //     setunsuitablePOList(response.data);
  //     setButtonLoading(false);
  //   } catch (err) {
  //     setButtonLoading(false);
  //   }
    
  // }, [poNumber]); // Include indentNo in the dependency array if getPOdata depends on it

 const getUnsutablePOdata = useCallback(async () => {
  if (!poNumber || poNumber.trim() === "") return;
  if (!gatepassNumberFromList || gatepassNumberFromList.trim() === "") return;

  setButtonLoading(true);

  try {
    const response = await apiClient.post(
      "/getUnsutablePO_by_PONumber",
      {
        ponumber: poNumber,
        gatepassnumber: gatepassNumberFromList,
      }

    );

    // if (response.data?.[0]?.unsuitabilitytype === "Suitable") {
    //   setSuitabilityDone("Suitable");
    // }

    if (response.data?.data?.[0]?.unsuitabilitytype === "Suitable") {
  setSuitabilityDone("Suitable");
}

    setunsuitablePOList(response.data.data || []);

//console.log("Unsuitable PO List:", response.data.data);


  } catch (err) {
    //🔥 ONLY THIS PART IS NEW
    if (err.response?.status === 425) {
     // console.log("No unsuitable PO data found for the given PO Number and Gate Pass.");
      setunsuitablePOList([]);
      return;
      
    }

    console.error(err);
  } finally {
    setButtonLoading(false);
  }
}, [poNumber, gatepassNumberFromList]);



  const InsertPOData = async (e) => {
    //e.preventDefault();
    setButtonLoading(true);
    let formErrors = {};
    //if (dateerror) formErrors.errDate = "Invalid Suitability Date";
    // if (memodateerror) formErrors.memoerrDate = "Invalid Memo Date";

    if (!memoDate) {
      formErrors.errMemoDate = "Invalid Memo Date";
    }

    if (!suitabilityDate) {
      formErrors.errDate = "Invalid Suitability Date";
    }

    let SelectionTypeValue = "0";

    if (parseFloat(receivedQuantity) < parseFloat(suitableQty))
      formErrors.qty = "Qty should be less or equel then received Qty";

    if (!suitableQty || parseFloat(suitableQty) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (selectedOption === "1") {
      if (reason.length === 0) formErrors.err = "Remark Should not be Blank";
      SelectionTypeValue = rejectReason;
    }

    if (selectedOption === "0") {
      SelectionTypeValue = "0";
      setReason(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Suitable Type Not Selected";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const podt = new Date(suitabilityDate);
      const indentreceiptdt =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();

      const memodt = new Date(memoDate);
      const memoreceiptdate =
        memodt.getFullYear() +
        "/" +
        parseInt(memodt.getMonth() + 1) +
        "/" +
        memodt.getDate();

      // console.log(poNumber);
      // console.log(suitableQty);
      // console.log(poQuantity);
      // console.log(indentreceiptdt);
      // console.log(memoreceiptdate);
      // console.log(SelectionTypeValue);
      // console.log(reason);
      // console.log(uname);
      // console.log(gatepassNumberFromList);
      // console.log(ip);

      apiClient
        .post("/sutabilityEntry", {
          vpoNumber: poNumber,
          vreceivedItemQty: suitableQty,
          vSuitabilityQty: poQuantity,
          vSuitabilityDate: indentreceiptdt,
          vMemoDate: memoreceiptdate,
          vsuitabilitystatus: SelectionTypeValue,
          vreason: reason + "",
          ventryUser: uname,
          vpassnumber: gatepassNumberFromList + "",
          vip: ip,
        })
        .then(function (response) {
          setError(response.data);
          getUnsutablePOdata();
          if (selectedOption === "0") {
            navigate("../suitabilitylist", { replace: true });
            
          }
          setButtonLoading(false);
          //
        })
        .catch(function (error) {
          // setsrcData([]);
          setError(error);
          setButtonLoading(false);
        });
       
    }
  };













const getdata = useCallback(async () => {
  if (!poNumberFromList?.trim()) return;
  if (!gatepassNumberFromList?.trim()) return;

  setButtonLoading(true);

  try {
    const response = await apiClient.post("/podetailssuitability", {
      uname,
      indentNumber: String(poNumberFromList),
      gatepassnumber: String(gatepassNumberFromList),
    });

    const data = response.data[0];

    setpoDate(data.PODate);
    setConsigneeName(data.POConsignee);
    setpoItemName(data.POItemName);
    setBalanceqty(data.balanceQty);
    setitemreceivedDate(data.itemReceivedDate);
    setreceivedQuantity(data.receivedItemQty);
    setreceivedvalue(data.receivedItemValue);
    setpoQuantity(data.receivedItemQty);
    setpoNumber(poNumberFromList);
    //setSuitableQuantity(data.balanceQty);
    setSuitableQuantity(data.receivedItemQty);  // change as per jpo on 19-03-2026
  } catch (error) {
    setError(error);
  } finally {
    setButtonLoading(false);
  }
}, [uname, poNumberFromList, gatepassNumberFromList]);




// 1️⃣ Load PO base details ONCE
useEffect(() => {
  getdata();
}, [getdata]);


// 2️⃣ Load unsuitable list ONLY when poNumber is ready
useEffect(() => {
  if (poNumber) {
    getUnsutablePOdata();
  }
}, [poNumber, getUnsutablePOdata]);



  const headers = [
    //["Indent Number","",""],
    ["PO Number", "PO date", "Gate Pass/Memo"],
    ["Item Name", "Consignee", "Received Value"],
    [
      "Material Received Date",
      "Material Received Quantity",
      "Balance Suitable Qty",
    ],
  ];

  const rows = [
    [poNumber, poDate, gatepassNumberFromList],
    [poItemName, ConsigneeName, receivedvalue],
    [item_receivedDate, receivedQuantity, balanceqty],
  ];

  const suitabilitymenuoptions = [
    { value: "0", label: " Item Suitable" },
    { value: "1", label: " Item Not Suitable" },
  ];

  const columns = [
    "unsuitabilitytype",
    "SuitabilityDate",
    "reason",
    "receivedItemQty",
  ];

  const columnNames = [
    "Inspection Remark",
    "Suitability/Unsuitability Date",
    "Reason",
    "Quantity",
  ]; // keys from your data objects

  ////// canclelation  tools
  const [showcancleRemark, setShowcancleRemark] = useState(false);
  const [cancleRemark, setcancleRemark] = useState("");

  const poCancelConfirm = async () => {
    
    const isConfirmed = window.confirm(
      `Are you sure to Return PO Number: ${poNumber}`
    );
    if (isConfirmed) {
      setShowcancleRemark(true);
      // focus after render
    setTimeout(() => {
      cancelRemarkRef.current?.focus();
    }, 100);

    } else {
      setShowcancleRemark(false);
      setcancleRemark("");
    }
  };

  const poReturn = async () => {
    const isConfirmed = window.confirm(
      `Are you sure to Return PO Number: ${poNumber}`
    );
    if (isConfirmed) {
      setPageLoader(true);
      try {
        //vpoNumber, vpassnumber, vreason, ventryUser, vip
        const response = await apiClient.post("/poreturn", {
          vponumber: poNumberFromList,
          vpassnumber: gatepassNumberFromList,
          ventryUser: uname,
          vip: ip,
          vreason: cancleRemark,
        });
        navigate("../suitabilitylist", { replace: true });
        setPageLoader(false);
        // navigate('../', { replace: true });
      } catch (error) {
        //alert(error);
        // navigate('../', { replace: true });
        navigate("../suitabilitylist", { replace: true });
        setPageLoader(false);
      }
    } else {
      setShowcancleRemark(false);
      setcancleRemark("");
      setPageLoader(false);
    }
  };
  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };
  return (
  <>
    <style>{`
      /* =========================================================
         SUITABILITY ENTRY - DASHBOARD THEME
         ========================================================= */

      .suitability-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        padding: 12px;

        overflow-x: hidden;
      }

      .suitability-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        background: #ffffff;

        border: 1px solid #dbe5f1 !important;
        border-radius: 16px !important;

        overflow: hidden;

        box-shadow:
          0 5px 18px rgba(13, 71, 161, 0.10) !important;
      }

      /* =========================================================
         HEADER
         ========================================================= */

      .suitability-header {
        width: 100%;
        min-height: 58px;

        display: flex;
        align-items: center;

        box-sizing: border-box;

        padding: 15px 20px;

        color: #ffffff;

        font-size: 20px;
        font-weight: 700;

        letter-spacing: 0.2px;

        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
      }

      .suitability-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        padding: 18px !important;
      }

      /* =========================================================
         PO DETAILS ACCORDION
         ========================================================= */

      .suitability-accordion {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-bottom: 20px !important;

        border: 1px solid #d7e4f5 !important;
        border-radius: 12px !important;

        overflow: hidden;

        box-shadow:
          0 3px 12px rgba(13, 71, 161, 0.07) !important;
      }

      .suitability-accordion::before {
        display: none;
      }

      .suitability-summary {
        min-height: 52px !important;

        padding: 0 16px !important;

        background: linear-gradient(
          135deg,
          #eaf3ff 0%,
          #f5f9ff 100%
        ) !important;

        color: #0d47a1 !important;
      }

      .suitability-summary .MuiAccordionSummary-content {
        margin: 12px 0 !important;
      }

      .suitability-summary
        .MuiAccordionSummary-expandIconWrapper {
        color: #1565c0;
      }

      .suitability-title {
        font-size: 16px !important;
        font-weight: 700 !important;
      }

      .suitability-accordion-details {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        padding: 16px !important;

        overflow: hidden;
      }

      /* =========================================================
         FORM SECTION
         ========================================================= */

      .suitability-form {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-top: 18px;
      }

      .suitability-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        display: grid;

        grid-template-columns:
          repeat(2, minmax(0, 1fr));

        gap: 16px;

        margin-top: 16px;
      }

      .suitability-field {
        width: 100%;
        min-width: 0;

        box-sizing: border-box;
      }

      /* =========================================================
         INSPECTION REASON SECTION
         ========================================================= */

      .suitability-rejection-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        display: grid;

        grid-template-columns:
          repeat(2, minmax(0, 1fr));

        gap: 16px;

        margin-top: 16px;

        padding: 14px;

        background: #f8fbff;

        border: 1px solid #dce9f7;

        border-radius: 10px;
      }

      /* =========================================================
         TABLE
         ========================================================= */

      .suitability-table-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-top: 22px;

        overflow: hidden;
      }

      .suitability-table-title {
        width: 100%;
        max-width: 100%;

        box-sizing: border-box;

        margin-bottom: 10px;

        padding: 10px 14px;

        background: linear-gradient(
          135deg,
          #edf5ff,
          #f7fbff
        );

        border-left: 4px solid #1565c0;

        border-radius: 7px;

        color: #0d47a1;

        font-size: 15px;
        font-weight: 700;

        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
      }

      .suitability-table-section table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
      }

      /* =========================================================
         ACTION BAR
         ========================================================= */

      .suitability-action-bar {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        display: flex;

        flex-wrap: wrap;

        justify-content: flex-end;

        gap: 12px;

        margin-top: 24px;
      }

      .suitability-action-btn {
        min-width: 135px;

        border: none;

        border-radius: 8px;

        padding: 10px 18px;

        color: #ffffff;

        font-size: 14px;

        font-weight: 700;

        cursor: pointer;

        box-shadow:
          0 3px 8px rgba(0, 0, 0, 0.12);

        transition: all 0.2s ease;
      }

      .suitability-action-btn:hover {
        transform: translateY(-1px);

        box-shadow:
          0 5px 12px rgba(0, 0, 0, 0.18);
      }

      .suitability-save-btn {
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
      }

      .suitability-return-btn {
        background: linear-gradient(
          135deg,
          #c62828,
          #e53935
        );
      }

      .suitability-close-btn {
        background: linear-gradient(
          135deg,
          #455a64,
          #607d8b
        );
      }

      .suitability-final-btn {
        background: linear-gradient(
          135deg,
          #212121,
          #424242
        );
      }

      .suitability-action-btn:disabled {
        opacity: 0.65;

        cursor: not-allowed;

        transform: none;

        box-shadow: none;
      }

      /* =========================================================
         CANCELLATION / RETURN SECTION
         ========================================================= */

      .suitability-cancel-box {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-top: 22px;

        padding: 18px;

        background: #fff8f8;

        border: 1px solid #ffcdd2;

        border-radius: 12px;
      }

      .suitability-cancel-title {
        margin-bottom: 12px;

        color: #b71c1c;

        font-size: 15px;

        font-weight: 700;
      }

      .suitability-cancel-action {
        display: flex;

        justify-content: flex-end;

        margin-top: 12px;
      }

      /* =========================================================
         LOADER
         ========================================================= */

      .suitability-loader {
        display: flex;

        align-items: center;

        justify-content: center;

        padding: 8px 20px;
      }

      /* =========================================================
         TABLET
         ========================================================= */

      @media (max-width: 900px) {

        .suitability-page {
          padding: 8px;
        }

        .suitability-content {
          padding: 14px !important;
        }

        .suitability-grid,
        .suitability-rejection-section {
          grid-template-columns: 1fr;
        }

        .suitability-action-bar {
          justify-content: stretch;
        }

        .suitability-action-btn {
          flex: 1 1 180px;
        }
      }

      /* =========================================================
         MOBILE
         ========================================================= */

      @media (max-width: 600px) {

        .suitability-page {
          padding: 4px;
        }

        .suitability-card {
          border-radius: 11px !important;
        }

        .suitability-header {
          min-height: 50px;

          padding: 13px 14px;

          font-size: 17px;
        }

        .suitability-content {
          padding: 10px !important;
        }

        .suitability-summary {
          padding: 0 10px !important;
        }

        .suitability-title {
          font-size: 14px !important;
        }

        .suitability-accordion-details {
          padding: 8px !important;
        }

        .suitability-form {
          margin-top: 12px;
        }

        .suitability-grid,
        .suitability-rejection-section {
          grid-template-columns: 1fr;

          gap: 10px;

          margin-top: 10px;
        }

        .suitability-rejection-section {
          padding: 10px;
        }

        .suitability-table-section {
          margin-top: 16px;
        }

        .suitability-table-title {
          font-size: 13px;

          padding: 8px 10px;
        }

        .suitability-action-bar {
          flex-direction: column;

          gap: 9px;

          margin-top: 18px;
        }

        .suitability-action-btn {
          width: 100%;

          min-width: 0;

          flex: none;
        }

        .suitability-cancel-box {
          margin-top: 16px;

          padding: 12px;
        }

        .suitability-cancel-action {
          width: 100%;
        }

        .suitability-final-btn {
          width: 100%;
        }
      }

      /* =========================================================
         VERY SMALL MOBILE
         ========================================================= */

      @media (max-width: 380px) {

        .suitability-header {
          font-size: 16px;
        }

        .suitability-content {
          padding: 7px !important;
        }

        .suitability-accordion-details {
          padding: 5px !important;
        }
      }
    `}</style>

    <div className="suitability-page">

      <Card className="suitability-card">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <div className="suitability-header">
          Suitability Details Entry
        </div>

        <CardContent className="suitability-content">

          {/* ===================================================
              PO DETAILS
          =================================================== */}

          <Accordion
            defaultExpanded
            className="suitability-accordion"
          >
            <AccordionSummary
              expandIcon={<ArrowDownwardIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="suitability-summary"
            >
              <Typography
                component="span"
                className="suitability-title"
              >
                PO Details
              </Typography>
            </AccordionSummary>

            <AccordionDetails
              className="suitability-accordion-details"
            >
              <ListHeaderTableComponent
                headers={headers}
                rows={rows}
              />
            </AccordionDetails>
          </Accordion>

          {/* ===================================================
              FORM
          =================================================== */}

          <div className="suitability-form">

            {/* Suitability + Quantity */}
            <div className="suitability-grid">

              <div className="suitability-field">
                <CustomDropdownMenu
                  options={suitabilitymenuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={errors.selerr}
                  menulabel="Select Suitability Option"
                />
              </div>

              <div className="suitability-field">
                <NumericTextField
                  id="receivedItemQuantity"
                  label="Suitable Item Quantity"
                  title="Suitable Item Quantity"
                  error={errors.qty}
                  value={suitableQty ?? "0"}
                  onChange={handleQuantityChange}
                  disabled={true}
                />
              </div>

            </div>

            {/* Memo Date + Suitability Date */}
            <div className="suitability-grid">

              <div className="suitability-field">
                <DatePickerComponent
                  label="Memo Receipt Date"
                  id="MemoReceiptDate"
                  value={memoDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setmemoDate
                    )
                  }
                  error={errors.errMemoDate}
                  maxDate={today}
                  minDate={
                    poDate
                      ? dayjs(poDate)
                      : dayjs()
                  }
                />
              </div>

              <div className="suitability-field">
                <DatePickerComponent
                  label="Suitability Date"
                  id="suitabilitydate"
                  value={suitabilityDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setsuitabilityDate
                    )
                  }
                  error={errors.errDate}
                  maxDate={today}
                  minDate={
                    poDate
                      ? dayjs(poDate)
                      : dayjs()
                  }
                />
              </div>

            </div>

            {/* =================================================
                NOT SUITABLE DETAILS
            ================================================= */}

            {!showRemark && (
              <div className="suitability-rejection-section">

                <div className="suitability-field">
                  <DropdownfromDatabaseList
                    Options={rejectReasons}
                    option={rejectReason}
                    setOptionValue={setRejectReason}
                    DisplayItem1="reason"
                    DisplayItem2="id"
                  />
                </div>

                <div className="suitability-field">
                  <CustomTextField
                    label="Reason Why Rejected ---> it should be not blank if Suitability not OK"
                    value={reason ?? ""}
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                    placeholder="Reason"
                    maxLength={100}
                    error={!!errors.err}
                    helperText={errors.err}
                  />
                </div>

              </div>
            )}

          </div>

          {/* ===================================================
              INSPECTION HISTORY TABLE
          =================================================== */}

          {Array.isArray(unsuitablePOList) &&
            unsuitablePOList.length > 0 &&
            suitabilityDone !== "Suitable" && (
              <div className="suitability-table-section">

                <div className="suitability-table-title">
                  Inspection / Suitability History
                </div>

                <TablewithSumFooter
                  columns={columns}
                  columnNames={columnNames}
                  data={unsuitablePOList}
                />

              </div>
            )}

          {/* ===================================================
              ACTION BUTTONS
          =================================================== */}

          <div className="suitability-action-bar">

            <button
              className="
                suitability-action-btn
                suitability-save-btn
              "
              type="button"
              onClick={InsertPOData}
              title="Click for Data Save"
              disabled={buttonLoading}
            >
              {buttonLoading
                ? "Saving..."
                : "Save Data"}
            </button>

            {unsuitablePOList.length > 0 &&
              suitabilityDone !== "Suitable" && (
                <button
                  className="
                    suitability-action-btn
                    suitability-return-btn
                  "
                  type="button"
                  onClick={poCancelConfirm}
                  title="Click for Return to Consignee"
                >
                  Return to Consignee
                </button>
              )}

            <button
              className="
                suitability-action-btn
                suitability-close-btn
              "
              type="button"
              onClick={handleClose}
              title="Close"
            >
              Close
            </button>

          </div>

          {/* ===================================================
              RETURN TO CONSIGNEE REMARK
          =================================================== */}

          {showcancleRemark && (
            <div className="suitability-cancel-box">

              <div className="suitability-cancel-title">
                Return to Consignee
              </div>

              <CustomTextField
                label="Remark --> it should be not blank"
                value={cancleRemark ?? ""}
                onChange={(e) => {
                  setcancleRemark(
                    e.target.value
                  );
                }}
                placeholder="Cancellation Reason"
                maxLength={50}
                error={!!errors.err}
                helperText={errors.err}
                inputRef={cancelRemarkRef}
              />

              <div className="suitability-cancel-action">

                {pageLoader ? (
                  <div className="suitability-loader">
                    <CircularProgress size={28} />
                  </div>
                ) : (
                  <button
                    className="
                      suitability-action-btn
                      suitability-final-btn
                    "
                    type="button"
                    onClick={poReturn}
                    title="Click for Return PO"
                  >
                    Click here: Finally Return
                  </button>
                )}

              </div>

            </div>
          )}

        </CardContent>
      </Card>
    </div>
  </>
);
}

export default SuitabilityEntry;
